import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AppstoreAddOutlined,
  DownOutlined,
  FileTextOutlined,
  HomeOutlined,
  MenuOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  ProfileOutlined,
  ScanOutlined,
  UpOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import BottomSheet from "./BottomSheet";

const QUICK_ACTIONS = [
  {
    key: "vente",
    label: "Nouvelle vente",
    icon: <PlusCircleOutlined />,
    color: "#2f9d62",
    path: "/gestion-pos",
  },
  {
    key: "produit",
    label: "Nouveau produit",
    icon: <AppstoreAddOutlined />,
    color: "#7c3aed",
    path: "/gestion-produits/produits?action=new",
  },
  {
    key: "client",
    label: "Nouveau client",
    icon: <UserAddOutlined />,
    color: "#0891b2",
    path: "/gestion-entites/clients",
  },
  {
    key: "inventaire",
    label: "Inventaire rapide",
    icon: <ProfileOutlined />,
    color: "#d97706",
    path: "/gestion-stock",
  },
];

export default function MobileBottomNav({
  onMenu,
  onQuickAction,
  menuOpen = false,
  homeLabel = "Accueil",
}) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [quickActionsOpen, setQuickActionsOpen] = useState(false);
  const [navHidden, setNavHidden] = useState(false);

  const isActive = (path) => pathname === path || pathname.startsWith(`${path}/`);

  useEffect(() => {
    if (menuOpen || quickActionsOpen) {
      setNavHidden(false);
    }
  }, [menuOpen, quickActionsOpen]);

  const goTo = (path) => {
    if (path) navigate(path);
  };

  const handleQuickAction = (action) => {
    setQuickActionsOpen(false);
    if (onQuickAction) {
      onQuickAction(action);
      return;
    }
    goTo(action.path);
  };

  const renderTab = (path, label, icon) => (
    <button
      type="button"
      className={`ea-tab ${isActive(path) ? "active" : ""}`}
      onClick={() => goTo(path)}
    >
      <span className="ea-tab__ic">{icon}</span>
      <span>{label}</span>
    </button>
  );

  return (
    <>
      {navHidden ? (
        <button
          type="button"
          className="ea-tabbar-peek"
          aria-label="Afficher la navigation mobile"
          onClick={() => setNavHidden(false)}
        >
          <UpOutlined />
          <span>Nav</span>
        </button>
      ) : (
        <nav className="ea-tabbar" aria-label="Navigation mobile principale">
          <button
            type="button"
            className="ea-tabbar__collapse"
            aria-label="Masquer la navigation mobile"
            onClick={() => setNavHidden(true)}
          >
            <DownOutlined />
          </button>
          {renderTab("/accueil", homeLabel, <HomeOutlined />)}
          {renderTab("/gestion-pos", "Caisse", <ScanOutlined />)}
          <div className="ea-tab ea-tab--fab">
            <button
              type="button"
              className="ea-fab"
              aria-label="Actions rapides"
              onClick={() => setQuickActionsOpen(true)}
            >
              <PlusOutlined />
            </button>
          </div>
          {renderTab("/gestion-ventes", "Ventes", <FileTextOutlined />)}
          <button
            type="button"
            className={`ea-tab ea-tab--menu ${menuOpen ? "active" : ""}`}
            onClick={onMenu}
          >
            <span className="ea-tab__ic">
              <MenuOutlined />
            </span>
            <span>Menu</span>
          </button>
        </nav>
      )}

      <BottomSheet
        open={quickActionsOpen}
        title="Actions rapides"
        onClose={() => setQuickActionsOpen(false)}
      >
        <div className="ea-qa-grid">
          {QUICK_ACTIONS.map((action) => (
            <button
              key={action.key}
              type="button"
              className="ea-qa"
              onClick={() => handleQuickAction(action)}
            >
              <span
                className="ea-qa__ic"
                style={{
                  background: `color-mix(in srgb, ${action.color} 12%, white)`,
                  color: action.color,
                }}
              >
                {action.icon}
              </span>
              <b>{action.label}</b>
            </button>
          ))}
        </div>
      </BottomSheet>
    </>
  );
}
